import { defineMessage } from 'react-intl';
import { getAnalyticsClickHandler } from '@eventbrite/legacy-infra.site-analytics';
import { HAS_WINDOW } from '@eventbrite/legacy-infra.feature-detection';
import {
    ACTION_HOST_AN_EVENT_CLICK,
    ACTION_HOST_AN_EVENT_HOVER,
    ACTION_ORGANIZE_AN_EVENT_HOVER,
    CATEGORY_HEADER,
    LABEL_CREATE_EVENT,
    LABEL_ORGANIZE_EVENT,
    UI_BLUE,
} from '../constants/tracking';

//TODO: [EB-279870] import correct one when it's available
// import {
//     ACTION_EVENT_CREATE_ATTEMPT,
//     PROPERTY_SOURCE_AUTOCREATE,
// } from '@eventbrite/event-create-analytics';
const ACTION_EVENT_CREATE_ATTEMPT = 'EventCreateAttempt';
const PROPERTY_SOURCE_AUTOCREATE = 'AutoCreate';

/**
 * Gets the info for displaying create event CTA to be passed to `callToActionInfo` prop of EDS Global Header
 * @param {string} serverUrl Base site URL (e.g. "http://www.eventbrite.com")
 * @param {string} ebDomain Current site domain
 * @param {string} [requestPath] Current request path (for analytics)
 * @param {boolean} [isAuthenticated] Whether or not the user is authenticated
 * @param {boolean} isExperiment Whether or not the user CTA is experimental
 * @param {object} [dimensions={} showCreateEventCTA={boolean}] Additional GA dimensions for when the CTA is clicked, a flag to determine if the createEventCTA should be rendered
 * @param {function} clickHandler Function that invokes when the element is clicked
 * @returns {object}
 */
export const getCreateEventCTA = (
    serverUrl,
    ebDomain,
    requestPath,
    isAuthenticated,
    isExperiment,
    { showCreateEventCTA = true, dimensions = {} } = {},
    clickHandler,
) => {
    if (!showCreateEventCTA) {
        return null;
    }

    const dataAttributes = {
        'data-automation': 'global-nav-create',
        onClick: () => {
            // New event tracking
            const hasPublish = (HAS_WINDOW && window.__SERVER_DATA__?.user.hasPublish) || false;
            const hasPaidPublish =
                (HAS_WINDOW && window.__SERVER_DATA__?.user.hasPaidPublish) || false;

            track({
                eventName: ACTION_EVENT_CREATE_ATTEMPT,
                eventData: {
                    eventCreateSource: PROPERTY_SOURCE_AUTOCREATE,
                    pageArea: 'CreateAnEventInListingPageHeader',
                    hasPublish: hasPublish,
                    hasPaidPublish: hasPaidPublish,
                },
            });

            getAnalyticsClickHandler(
                {
                    requestPath,
                    action: ACTION_HOST_AN_EVENT_CLICK,
                    category: CATEGORY_HEADER,
                    label: LABEL_CREATE_EVENT,
                    dimensions,
                },
                {
                    checkpointName: 'hiw_global_header_cta_clicked',
                    pageWillChange: isAuthenticated,
                    domain: ebDomain,
                },
            )();
            if (clickHandler) {
                clickHandler();
            }
        },
        style: { color: UI_BLUE },
        onMouseLeave: getAnalyticsClickHandler({
            requestPath,
            action: isExperiment ? ACTION_ORGANIZE_AN_EVENT_HOVER : ACTION_HOST_AN_EVENT_HOVER,
            category: CATEGORY_HEADER,
            label: isExperiment ? LABEL_ORGANIZE_EVENT : LABEL_CREATE_EVENT,
        }),
    };

    return {
        url: `${serverUrl}/manage/events/auto-create/`,
        content: isExperiment
            ? defineMessage({ id: 'Organize an event', defaultMessage: 'Organize an event' })
            : defineMessage({ id: 'Create an event', defaultMessage: 'Create an event' }),
        ...dataAttributes,
    };
};

const track = (data) => {
    HAS_WINDOW &&
        window?.dataLayer.push({
            event: 'track',
            sendToHeap: true,
            ...data,
        });
};
